<div mat-dialog-title class="dialog-title-row">
  <h2>Product Filename Validation</h2>
</div>
<mat-dialog-content class="validation-dialog-content">
  <div class="summary-stats">
    <div class="stat-row">
      <span class="stat-label">Products:</span>
      <span class="stat-value">{{ data.totalProducts }}</span>
    </div>
    <div class="stat-row files-row">
      <span class="stat-label">Files:</span>
      @if (stillsCount > 0) {
        <span class="stat-value">stills {{ stillsCount }}</span>
      }
      @if (videosCount > 0) {
        <span class="stat-value">videos {{ videosCount }}</span>
      }
      @if (jsonFilesCount > 0) {
        <span class="stat-value">JSON {{ jsonFilesCount }}</span>
      }
      <span class="stat-value total">total {{ totalFilesCount }}</span>
    </div>
    <div class="stat-row">
      <span class="stat-label">Filenames:</span>
      @if (stillsCount > 0) {
        <span class="stat-value">stills {{ stillsCount }}</span>
      }
      @if (videosCount > 0) {
        <span class="stat-value">videos {{ videosCount }}</span>
      }
      <span class="stat-value valid">valid {{ validFilenamesCount }}</span>
      @if (invalidFilenamesCount > 0) {
        <span class="stat-value invalid">invalid {{ invalidFilenamesCount }}</span>
      }
    </div>
    @if (data.validateProductDataExport && (labelWarningsCount > 0 || duplicateBarcodeCount > 0)) {
      <div class="stat-row">
        <span class="stat-label">Label Warnings:</span>
        @if (labelWarningsCount > 0) {
          <span class="stat-value invalid">{{ labelWarningsCount }} invalid JSON filename</span>
        }
        @if (duplicateBarcodeCount > 0) {
          <span class="stat-value invalid">{{ duplicateBarcodeCount }} duplicate barcodes</span>
        }
      </div>
    }
  </div>

  <table class="validation-table">
    <thead>
      <tr>
        <th class="col-status"></th>
        <th class="col-product">Product</th>
        <th class="col-format">Format</th>
        <th class="col-patterns">Patterns → Filenames</th>
      </tr>
    </thead>
    <tbody>
      @for (row of groupedRows; track row) {
        <tr [class.invalid]="!row.valid" [class.product-even]="row.productGroup % 2 === 0" [class.product-odd]="row.productGroup % 2 === 1">
          <td class="col-status">
            <mat-icon [color]="row.valid ? 'primary' : 'warn'">
              {{ row.valid ? 'check_circle' : 'error' }}
            </mat-icon>
          </td>
          <td class="col-product">
            <span class="product-identifier">{{ row.product.barcode || row.product.reference }}</span>
            <button class="icon-btn" (click)="openEditProduct(row.product)" title="Edit product">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
          <td class="col-format">
            <span class="format-name">{{ row.formatName }}</span>
          </td>
          <td class="col-patterns">
            @for (preview of row.stills; track preview) {
              <div class="pattern-group" [class.invalid]="!preview.valid">
                <span class="type-indicator type-stills" matTooltip="Stills ({{ preview.from }}{{ preview.to ? '-' + preview.to : '+' }})">S</span>
                <code class="token-display pattern">
                  @for (token of preview.patternTokens; track token) {
                    <span [ngClass]="getTokenColorClass(token.type)">{{ token.text }}</span>
                  }
                </code>
                <span class="arrow">→</span>
                <code class="token-display filename" [class.error]="!preview.valid">
                  @for (token of preview.filenameTokens; track token) {
                    <span [ngClass]="[getTokenColorClass(token.type), token.valid ? '' : 'invalid-fragment']">{{ token.text }}</span>
                  }
                </code>
              </div>
            }
            @for (preview of row.videos; track preview) {
              <div class="pattern-group" [class.invalid]="!preview.valid">
                <span class="type-indicator type-videos" matTooltip="Videos ({{ preview.from }}{{ preview.to ? '-' + preview.to : '+' }})">V</span>
                <code class="token-display pattern">
                  @for (token of preview.patternTokens; track token) {
                    <span [ngClass]="getTokenColorClass(token.type)">{{ token.text }}</span>
                  }
                </code>
                <span class="arrow">→</span>
                <code class="token-display filename" [class.error]="!preview.valid">
                  @for (token of preview.filenameTokens; track token) {
                    <span [ngClass]="[getTokenColorClass(token.type), token.valid ? '' : 'invalid-fragment']">{{ token.text }}</span>
                  }
                </code>
              </div>
            }
            @for (preview of row.json; track preview) {
              <div class="pattern-group" [class.invalid]="!preview.valid">
                <span class="type-indicator type-json" matTooltip="JSON">J</span>
                <code class="token-display pattern">
                  @for (token of preview.patternTokens; track token) {
                    <span [ngClass]="getTokenColorClass(token.type)">{{ token.text }}</span>
                  }
                </code>
                <span class="arrow">→</span>
                <code class="token-display filename" [class.error]="!preview.valid">
                  @for (token of preview.filenameTokens; track token) {
                    <span [ngClass]="[getTokenColorClass(token.type), token.valid ? '' : 'invalid-fragment']">{{ token.text }}</span>
                  }
                </code>
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
